import React, { useEffect } from 'react';
import Footer from "../Components/Footer/Footer";
import Navigation from "../Components/Navbar/Navigation";
import WheelerBanner from "../Components/Property/WheelerBanner";
import TwoWheelerContent from "../Components/Property/TowWheelerContent";
import {Helmet} from "react-helmet";
export default function TwoWheeler() {
  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  return (
    <div className="innerpages-nav">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Two Wheeler Details</title>
        <link rel="canonical" href={window.location.href} />
        <meta name="description" content="" />
        <meta name="keywords" content="Two Wheeler" />
        <meta name="author" content="DALMaf" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0"/>
      </Helmet>
       <div id="container">
      <Navigation />
      <WheelerBanner />
      <TwoWheelerContent />
      <Footer />
      </div>
    </div>
  );
}
